export const ZKSYNC_IMPLEMENTATIONS: Record<number, Record<string, string>> = {
  [300]: {
    MarketplaceV3: "0x58e0F289C7dD2025eBd0696d913ECC0fdc1CC8bc",
  },
  [302]: {
    MarketplaceV3: "0x8b0DBCf5b7D01eBB0F24525CE8AB72F16CE4F8C8",
  },
  [324]: {
    MarketplaceV3: "0xBc02441a36Bb4029Cd191b20243c2e41B862F118",
  },
  [11124]: {
    MarketplaceV3: "0x2dA4Dd326A6482679547071be21f74685d730504",
  },
  [37111]: {
    MarketplaceV3: "0x56Abb6a3f25DCcdaDa106191053b1CC54C196DEE",
  },
  [555271]: {
    MarketplaceV3: "0x9EB0830B0b10010F2a53383517A7D0B75531Bb1b",
  },
  [2741]: {
    MarketplaceV3: "0x4027561E163a420c4e5Db46E07EBd581CAa8Bb62",
  },
};

export const ZKSYNC_WETH: Record<number, string> = {
  [300]: "0x0462C05457Fed440740Ff3696bDd2D0577411e34",
  [324]: "0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91",
  [11124]: "0x9EDCde0257F2386Ce177C3a7FCdd97787F0D841d",
  [37111]: "0xaA91D645D7a6C1aeaa5988e0547267B77d33fe16",
  [555271]: "0xb0b8b267d44c64BA6dD1Daf442949887c85199f6",
  [2741]: "0x3439153EB7AF838Ad19d56E1571FBD09333C2809",
};
